import { useEffect, useRef } from "react";
import { Back, Elastic, gsap } from "gsap";

import ExpandedNavigation from "./ExpandedNavigation";
import Logo from "./Logo";
import Navigation from "./Navigation";
import SocialsNav from "./SocialsNav";

import { color } from "../designTokens";

const Navbar = () => {
  const enRef = useRef();
  const tlH = useRef(gsap.timeline());
  const tlV = useRef(gsap.timeline());

  const openNavigationMenu = () => {
    tlH.current
      .to(enRef.current, {
        scaleY: 1,
        duration: 1,
        ease: Elastic.easeOut.config(0.5, 0.5),
      })
      .to(".nav .inverseNav", { color: color.secondary }, "-=0.9")
      .to(".nav path, .nav circle", { fill: color.secondary }, "<")
      .to(".nav circle[stroke]", { stroke: color.primary }, "<")
      .to(
        ".navigation svg",
        { rotate: "-180deg", duration: 0.5, ease: Back.easeOut.config(0.3) },
        "<"
      );
  };

  const openSideMenu = () => {
    tlV.current
      .to(enRef.current, {
        scaleX: 1,
        duration: 1,
        ease: Elastic.easeOut.config(0.5, 0.5),
      })
      .to(
        ".scrolled-navburger",
        {
          backgroundColor: color.secondary,
          duration: 0.5,
        },
        "<"
      );

    console.log(enRef.current.classList);

    tlV.current.play();
  };

  useEffect(() => {
    document.querySelector(".navigation").addEventListener("mouseenter", () => {
      openNavigationMenu();
      tlH.current.play();
    });

    document
      .querySelector(".exp-nav-common")
      .addEventListener("mouseleave", () => {
        tlH.current.reverse(0.25);
        tlV.current.reverse(0.25);
      });

    // gsap.to(enRef.current, {
    //   scrollTrigger: {
    //     trigger: ".nav",
    //     start: "top top+=25",
    //     end: "bottom top+=50",
    //     scrub: true,
    //     // markers: true,
    //     onLeave: () => {
    //       enRef.current.classList.remove("exp-nav-horizontal");
    //       enRef.current.classList.add("exp-nav-vertical");
    //     },
    //   },
    // });

    // gsap.to(".scrolled-navburger", {
    //   scrollTrigger: {
    //     trigger: ".nav",
    //     start: "center top",
    //     end: "top-=1000 top",
    //     scrub: 0.75,
    //     markers: true,
    //     onEnter: () => {
    //       enRef.current.classList.remove("exp-nav-vertical");
    //       enRef.current.classList.add("exp-nav-horizontal");
    //     },
    //   },
    //   scale: 1,
    //   opacity: 1,
    //   duration: 0.3,
    // });
  });

  return (
    <div className="nav">
      <Logo />
      <Navigation />
      <ExpandedNavigation refer={enRef} />
      <SocialsNav />
      {/* <div className="scrolled-navburger" onClick={openSideMenu}></div> */}
    </div>
  );
};

export default Navbar;
